import React from "react";
import { Link } from "react-router-dom";
import Layout from "./Components/Layout";
import styles from "./styles/Auth.module.css";

export default function RegisterSuccess() {
  return (
    <Layout
      title="Registration successful - My Chinese Horoscope"
      description="Your account has been created successfully."
      keywords="registration successful, login"
    >
      <div className={styles.card}>
        <h1>Registered successfully</h1>
        <p className={styles.subtitle}>Your account has been created. You may log in now.</p>

        <div style={{ marginTop: 24, display: "flex", gap: 14, flexWrap: "wrap", alignItems: "center" }}>
          <Link
            to="/login"
            style={{
              display: "inline-block",
              background: "#7b1207",
              color: "#fff",
              textDecoration: "none",
              borderRadius: 12,
              padding: "12px 18px",
              fontWeight: 700,
            }}
          >
            Go to login
          </Link>

          <Link to="/" style={{ textDecoration: "none", color: "#111" }}>
            Back to home
          </Link>
        </div>
      </div>
    </Layout>
  );
}
